module.exports = __webpack_public_path__ + "img/phone.c1da0e3b.svg";